import { memo } from 'react';
import { getPriorityConfig } from '../../constants/suggestionWizard';

interface ConfidenceDotsProps {
  priority: string;
}

/**
 * Visual indicator for signal priority/confidence level.
 * Shows 1-3 filled dots based on priority (low/medium/high).
 */
export const ConfidenceDots = memo<ConfidenceDotsProps>(({ priority }) => {
  const config = getPriorityConfig(priority);

  return (
    <div className="flex items-center gap-0.5" title={`${config.label} confidence`}>
      {[1, 2, 3].map((dot) => (
        <div
          key={dot}
          className={`w-1.5 h-1.5 rounded-full ${dot <= config.dots ? config.color : 'bg-gray-200'}`}
        />
      ))}
    </div>
  );
});

ConfidenceDots.displayName = 'ConfidenceDots';

export default ConfidenceDots;
